import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";

import { attackSurfaceKeys } from "./access-query-key-factory";

/**
 * Returns a list of all attack surfaces within a given project
 *
 * @param {string} projectId - uuid of project
 * @returns list of all attack surfaces within the given project
 */
export const getAttackSurfaces = async ({ projectId }: { projectId: string }) => {
  return Brm.attackSurfaceApi.findAttackSurface(projectId);
};

interface IUseAttackSurfaces {
  projectId: string;
  options?: QueryOption<typeof getAttackSurfaces>;
}

/**
 * Custom-hook to retrieve all attack surfaces for a project.
 *
 * @param {string} projectId - uuid of project
 * @param {object} options - react-query configuration object
 * @returns react-query for findAttackSurfaces
 */
export const useAttackSurfaces = ({ projectId, options = {} }: IUseAttackSurfaces) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: attackSurfaceKeys.project(projectId),
    queryFn: () => getAttackSurfaces({ projectId }),
  });
};
